document.addEventListener("turbolinks:load", function () {
  delete window?.updateSessionData;

  // Do not execute any of this code if we are not on the IA builder page.
  if (document.querySelector("#builder-container") == null) {
    return;
  }

  // Updates session data based to allow for resuming assignment creation.
  window.updateSessionData = function() {
    // console.log("update session data");
    tinymce.triggerSave();
    let form = $("#immersive_assignment_form").get(0);
    if (form?.dataset.actionName === "new") {
      let formData = new FormData(form);
      formData.delete("_method");
      // Send data in AJAX request to be read by the Application Controller
      $.ajax({
        url: "/immersive_assignments/builder/save_form_data",
        type: "POST",
        data: formData,
        processData: false,
        contentType: false,
        success: function (response) {
          // console.log("success saving session data");
        }
      });
    }
  }

  let activityListIdSelector = "#activity-list";
  let builderContainerIdSelector = "#builder-container";
  let droppableAreaIdSelector = "#asset-droppable-area";
  let addLinkButtonIdSelector = "#add-link-button";
  let addLinkInputIdSelector = "#add-link-input-field";
  let assignmentFolderNamePickerSelector = "#assignment-folder-name-picker";
  const tinyMceContentStyle = "body { font-size: 14px; }";

  const setupDescriptionEditorAccessibility = function(editor) {
    const $source = $(editor.getElement());
    const label = $source.attr("aria-label");
    const placeholder = $source.attr("placeholder");
    const removeAriaPlaceholder = function() {
      if ($source.data("editor-remove-aria-placeholder")) {
        $(editor.getBody()).removeAttr("aria-placeholder");
      }
    };

    if (label != null) {
      const accessibleLabel = placeholder
        ? `${label}. Placeholder: ${placeholder}`
        : label;

      // TinyMCE applies aria-placeholder during init and whenever its placeholder
      // state changes, so remove it after TinyMCE sets it.
      editor.on("PlaceholderToggle", removeAriaPlaceholder);

      editor.on("PreInit", function () {
        const $body = $(editor.getBody());
        const $editorContainer = $(editor.getContainer());
        const $application = $editorContainer
          .filter('div[role="application"]')
          .add($editorContainer.find('div[role="application"]'))
          .first();

        // Match TinyMCE's newer single-announcement behavior before the editor receives focus.
        $application.removeAttr("aria-label");

        if (tinymce.Env.browser.isFirefox()) {
          $body.removeAttr("aria-label");
          if (editor.iframeElement != null) {
            $(editor.iframeElement).attr("title", accessibleLabel);
          }
        } else {
          $body.attr("aria-label", accessibleLabel);
          if (editor.iframeElement != null) {
            $(editor.iframeElement).removeAttr("title");
          }
        }

        if ($source.data("editor-remove-aria-placeholder")) {
          removeAriaPlaceholder();
        }
      });
    }
  };

  // Validated fields and errors
  const assignmentName = document.querySelector("#assignment-title");
  const assignmentNameError = document.querySelector("#assignment-title-error");
  const startDatePicker = document.querySelector("#assignment-datepicker-start-date");
  const startDateError = document.querySelector("#assignment-datepicker-start-date-error");
  const dueDatePicker = document.querySelector("#assignment-datepicker-due-date");
  const dueDateError = document.querySelector("#assignment-datepicker-due-dat-error");
  const folderName = document.querySelector("#assignment-group-folder-name-input");
  const folderNameError = document.querySelector("#assignment-group-folder-name-input-error");

  // Folder dropdown
  const folderDropdown = document.querySelector("#assignment-folder-name-picker");

  // Display the assignment name error if it is blank; otherwise hide it
  const validateAssignmentName = function() {
    assignmentName.value.trim() === "" ? showVbError(assignmentNameError) : hideVbError(assignmentNameError);
  }

  // Display the activity name error if it is blank; otherwise hide it
  const validateActivityName = function(activityName) {
    const activityNameError = activityName
      .closest(".builder-activity-card")
      .querySelector(".vb_error__container");
    activityName.value.trim() === "" ? showVbError(activityNameError) : hideVbError(activityNameError);
  }

  // Assignment Name Validation
  assignmentName.addEventListener("blur", () => {
    validateAssignmentName();
    determineContinueButtonStates();
  });

  // Start Date Validation
  startDatePicker?.addEventListener("change", () => {
    const startDate = new Date(startDatePicker.value);
    let dueDate = new Date(dueDatePicker.value);
    // If the due date is before or equal to the start date, set it to 1 week after the start date at 11:59
    if (dueDate <= startDate) {
      // Create the new date
      const newDueDate = new Date(startDate.setDate(startDate.getDate() + 7));
      newDueDate.setHours(23,59,59,999);
      // Update the due date on the page and locally for validation
      dueDatePicker._flatpickr.setDate(newDueDate);
      dueDate = newDueDate;
    }
    // If the due date is before the start date, show the error. Otherwise hide it
    dueDate <= startDate ? showVbError(startDateError) : hideVbError(startDateError);
    // If the start date is before the due date, hide the due date error
    if (startDate < dueDate) hideVbError(dueDateError);
    determineContinueButtonStates();
  });

  // Due Date Setup
  dueDatePicker?.addEventListener("focus", () => {
    // Set the minimum due date to the start date
    dueDatePicker._flatpickr.set("minDate", (new Date(startDatePicker.value)));
  });

  // Due Date Validation
  dueDatePicker?.addEventListener("change", () => {
    const currentTime = new Date();
    const startDate = new Date(startDatePicker.value);
    const dueDate = new Date(dueDatePicker.value);
    // If the due date is before the start date or current date, show the error. Otherwise hide it
    const dueDateTooEarly = dueDate <= startDate || dueDate < currentTime;
    dueDateTooEarly ? showVbError(dueDateError) : hideVbError(dueDateError);
    // If the due date is after the start date, hide the start date error
    if (dueDate > startDate) hideVbError(startDateError);
    determineContinueButtonStates();
  });

  // Folder Name Validation
  folderName?.addEventListener("blur", () => {
    // If the string is empty or only white space, show the error. Otherwise hide it
    folderName.value.trim() === "" ? showVbError(folderNameError) : hideVbError(folderNameError);
    determineContinueButtonStates();
  });

  // Folder Option Selection
  folderDropdown?.addEventListener("change", () => {
    // If the "Create new" option is selected (value of "-1"), show or hide the error as appropriate
    if (folderDropdown.value === "-1") {
      // If the string is empty or only white space, show the error. Otherwise hide it
      folderName.value.trim() === "" ? showVbError(folderNameError) : hideVbError(folderNameError);
    }
    // If anything other than "Create new" is selected, hide the error
    else {
      hideVbError(folderNameError);
    }
    determineContinueButtonStates();
  });

  // Function for updating the assignment activity link order on each activity card in the activity list.
  const updateActivityOrder = function(shouldUpdateSessionData = true) {
    let activityCards = $("#activity-list .builder-activity-card")
    activityCards.each(function(index) {
      $(this).find('[data-field-name="link_order"]').val(index);
    })
    if (shouldUpdateSessionData) {
      updateSessionData();
    }
  }

  // Initialize builder tooltips that cannot use data-bs-toggle because another Bootstrap behavior owns it.
  const initializeBuilderTooltips = function() {
    document
      .querySelectorAll("[data-builder-tooltip='true']")
      .forEach((element) => {
        const existingTooltip = bootstrap.Tooltip.getInstance(element);
        if (existingTooltip != null) {
          existingTooltip.dispose();
        }

        new bootstrap.Tooltip(element);
      });
  }

  // Only show title tooltips when the card title is actually truncated.
  const initializeAssetCardTitleTooltips = function() {
    document
      .querySelectorAll(".immersive-asset-card__title[data-full-title]")
      .forEach((titleElement) => {
        const fullTitle = titleElement.dataset.fullTitle;
        const isOverflowing =
          titleElement.scrollWidth > titleElement.clientWidth ||
          titleElement.scrollHeight > titleElement.clientHeight;

        const existingTooltip = bootstrap.Tooltip.getInstance(titleElement);
        if (existingTooltip != null) {
          existingTooltip.dispose();
        }

        if (!isOverflowing) {
          titleElement.removeAttribute("title");
          return;
        }

        titleElement.setAttribute("title", fullTitle);
        new bootstrap.Tooltip(titleElement);
      });
  }

  // Updates the assignments total point value.
  // Displayed above the activity list only if there are activities,
  // otherwise it's style is being hidden.
  const updateAssignmentPointDisplay = function(shouldUpdateSessionData = true) {
    let assignmentTotalPoints = $("#assignment-total-points");
    let totalPoints = 0;
    let activityPoints = $(".activity-points-for-assignment-total")
    const hasActivities = activityPoints.length !== 0;

    assignmentTotalPoints.toggleClass("builder-container__assignment-points_hidden", !hasActivities);

    if (hasActivities) {
      activityPoints.each(function(index, points) {
        totalPoints += Number($(points).val())
      });
      assignmentTotalPoints.text("Total Points: " + Number(totalPoints));
      $("#assignment-point-value-form-field").val(totalPoints);
      $("#assignment-settings-show-in-gradebook-field").val("false");

    } else {
      assignmentTotalPoints.text("");
      $("#assignment-point-value-form-field").val(0);
    }
    if (shouldUpdateSessionData) {
      updateSessionData();
    }
  }

  // Determines the state of each of the "continue" buttons on the page.
  const determineContinueButtonStates = function() {
    let activityListCount = $(activityListIdSelector).children().length;
    updateContinueButtonStates(!checkForVbErrors() && activityListCount > 0);
  }

  // Set the state of the continue button based on the provided value.
  const updateContinueButtonStates = function(enabled) {
    let $publishButton = $("#ia-publish-button");
    setButtonState($publishButton, enabled);
    let $saveDraftButton = $("#ia-save-draft-button");
    setButtonState($saveDraftButton, enabled);
    let $saveChangesButton = $("#builder-save-changes-button");
    setButtonState($saveChangesButton, enabled);
    let $saveAsNewButton = $("#builder-save-as-new-button");
    setButtonState($saveAsNewButton, enabled);
    let $updateAssignmentButton = $("#builder-update-assignment-button");
    setButtonState($updateAssignmentButton, enabled);
  };

  // Sets the state of the provided button based on the provided enabled value
  // Used for bootstrap button system
  const setButtonState = function($button, enabled) {
    if ($button) {
      if (enabled) {
        if ($button.hasClass("btn-disabled")) {
          $button.removeClass("btn-disabled");
        }
        if ($button.is("[aria-disabled]")) {
          $button.removeAttr("aria-disabled");
        }
        if ($button.is("[disabled]")) {
          $button.removeAttr("disabled");
        }
      } else {
        if (!$button.hasClass("btn-disabled")) {
          $button.addClass("btn-disabled");
        }
        if (!$button.is("[aria-disabled]")) {
          $button.attr("aria-disabled", true);
        }
        if (!$button.is("[disabled]")) {
          $button.attr("disabled", "disabled");
        }
      }
    }
  }

  // Sets the state of the empty activity list message based on the provided value.
  const updateEmptyActivityListMessage = function(enabled) {
    let $messageContainer = $("#empty-activity-list-container");
    if (enabled) {
      if ($messageContainer.hasClass("hidden")) {
        $messageContainer.removeClass("hidden");
      }
    } else {
      if (!$messageContainer.hasClass("hidden")) {
        $messageContainer.addClass("hidden")
      }
    }
  };

  // Callback for when the activity list count has changed.
  const handleActivityCountChanged = function() {
    let activityListCount = $(activityListIdSelector).children().length
    updateActivityOrder(false);
    updateAssignmentPointDisplay(false);
    determineContinueButtonStates();
    updateEmptyActivityListMessage(activityListCount === 0)
    updateSessionData();
  }

  // LEFT SIDE
  // Functionality for selecting assets to move to right side for assignment building
  // Set draggable properties for asset cards
  $(".immersive-asset-card").draggable({
    helper: "clone",
    opacity: 1,
    connectToSortable: activityListIdSelector,
    appendTo: builderContainerIdSelector,
    containment: builderContainerIdSelector,
    start: function (event, ui) {
      ui.helper.addClass("immersive-asset-card_dragging");
      assetDragStartHandler();
      $(activityListIdSelector).sortable({
        opacity: 1,
      });
    },
    stop: function (event, ui) {
      assetDragEndHandler();
      $(activityListIdSelector).sortable({
        opacity: 0.5,
      });
    },
  });

  // Function for adding a new activity, based on an existing asset card, to the activity list.
  // @param assetCard: the asset card element to add
  // @param putLast: boolean to determine whether to put new item last, or in place
  function addActivityFromAssetCard(assetCard, index = null) {
    // Send data in AJAX request to be read by the Application Controller
    $.ajax({
      url: "/immersive_assignments/new_activity_card",
      type: "GET",
      dataType: "html",
      data: {
        id: assetCard.data("assetId"),
        class_name: assetCard.data("className"),
        asset_type_id: assetCard.data("assetTypeId")
      },
      success: function (response) {
        addNewActivityCard($(response), true, index);
      }
    });
  }
  window.addActivityFromAssetCard = addActivityFromAssetCard;

  // Function for adding a new activity, based on the provided link URL, to the activity list.
  // @param linkUrl: the link URL for the new activity card
  // @param putLast: boolean to determine whether to put new item last, or in place
  function addActivityFromLink(linkUrl) {
    // Send data in AJAX request to be read by the Application Controller
    $.ajax({
      url: "/immersive_assignments/new_activity_card",
      type: "GET",
      dataType: "html",
      data: {
        url: linkUrl,
        class_name: "link_asset"
      },
      success: function (response) {
        addNewActivityCard($(response), true);
      }
    });
  }

  // Function to remove activity from the list
  const removeActivity = function () {
    let $activityCard = $(this).closest(".builder-activity-card")
    let $previousCard = $($activityCard.get(0).previousElementSibling);
    let $nextCard = $($activityCard.get(0).nextElementSibling);
    $activityCard.remove();
    updateReorderButtonStates($previousCard);
    updateReorderButtonStates($nextCard);
    handleActivityCountChanged();
  };

  // Adds a new activity card to the activity list.
  const addNewActivityCard = function($activityCard, scrollIntoView, index = null) {
    let $activityList = $(activityListIdSelector);
    if (index == null || $activityList.children().length === 0 || index >= $activityList.children().length) {
      $activityList.append($activityCard);
    } else {
      $activityList.children().eq(index).before($activityCard);
    }
    initActivityCard($activityCard, scrollIntoView);
    updateReorderButtonStates($($activityCard.get(0).previousElementSibling));
    updateReorderButtonStates($($activityCard.get(0).nextElementSibling));
    handleActivityCountChanged();
  }

  // Initializes the activity card with additional functionality.
  // This includes, but is not limited to, initializing tinyMCE
  // for additional edit options within the activity's description box.
  const initActivityCard = function ($activityCard, scrollIntoView) {
    // Set Click and Keydown (Enter) events to remove the activity from the list
    const removeIcon = $activityCard.find(".builder-activity-card__remove-button");
    removeIcon.on("click", removeActivity);
    removeIcon.on("keydown", (event) => {
      if (event.key === "Enter") {
        removeActivity.call($activityCard);
      }
    });

    // Prevents new lines from being created in the activity title input field.
    let activityTitle = $activityCard.find(".activity-title")
    activityTitle.keydown(function (e) {
        // Enter has been pressed
        if (e.keyCode === 13) {
          // Prevent the text area from creating a new line
          e.preventDefault();
        }
      });

    // Callback when the activity title loses focus.
    $(activityTitle).on("blur", function() {
      updateSessionData();
      validateActivityName(this);
      determineContinueButtonStates();
    });

    // Add callback to the settings button
    $activityCard.find(".edit-activity-settings-button").on("click", function () {
      $activityCard.attr("editing-settings", true);
    });

    // Add listener for when the activity point value field has changed.
    $activityCard.find(".activity-points-for-assignment-total").change(function() {
      onPointValueChanged(this);
    });

    let $scrollUpButton = $activityCard.find(".builder-activity-card__controls-arrow[data-reorder-direction='up']");
    $scrollUpButton.on("click", function() {
      reorderActivityCards($(activityListIdSelector).get(0), function() { scrollUpReorder($activityCard); });
    });

    let $scrollDownButton = $activityCard.find(".builder-activity-card__controls-arrow[data-reorder-direction='down']");
    $scrollDownButton.on("click", function() {
      reorderActivityCards($(activityListIdSelector).get(0), function() { scrollDownReorder($activityCard); });
    });
    updateReorderButtonStates($activityCard);
    updateActivityCounter();

    // Initialize the tinyMCE edit options.
    let descriptionElement = $activityCard.find(".activity-description").get(0);
    if (descriptionElement != null) {
      tinymce.init({
        selector: "textarea#" + $(descriptionElement).attr("id"),
        plugins: "lists",
        menubar: false,
        statusbar: false,
        browser_spellcheck: true,
        contextmenu: false,
        height: $(descriptionElement).height(),
        toolbar: "bullist | bold italic | forecolor",
        lists_indent_on_tab: false,
        paste_as_text: true,
        content_style: tinyMceContentStyle,
        formats: {
          bold: { inline: "b" },
          italic: { inline: "i" },
        },
        extended_valid_elements: "b,i",
        invalid_elements: "em strong",
        init_instance_callback: function (editor) {
          if (scrollIntoView && rightSideEnabled()) {
            $activityCard.get(0).scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
          editor.on("focus", function (e) {
            // Show the toolbar when gaining focus.
            $(e.target.iframeElement
              .closest(".tox-editor-container")
              .querySelector(".tox-editor-header")
            ).show();
            // Increase the height of the description box.
            $(e.target.iframeElement.closest(".tox-tinymce")).height(300);
          });
          editor.on("blur", function (e) {
            // Hide the toolbar when losing focus.
            updateSessionData();
            $(e.target.iframeElement
              .closest(".tox-editor-container")
              .querySelector(".tox-editor-header")
            ).hide();
            // Shrink the height of the description box back to its original.
            $(e.target.iframeElement.closest(".tox-tinymce")).height($(descriptionElement).height());
          });
        },
        setup: function (editor) {
          setupDescriptionEditorAccessibility(editor);
          editor.on("init", function (e) {
            // Hide the toolbar by default.
            $(e.target.iframeElement
              .closest(".tox-editor-container")
              .querySelector(".tox-editor-header")
            ).hide();
            // Show the activity card data (e.g. activity title, description, etc.)
            $(e.target.iframeElement.closest(".builder-activity-card__description-container")).show();
          });
        },
      });
    }
    else if (scrollIntoView && rightSideEnabled()) {
      $activityCard.get(0).scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  // Function for reordering an activity card down a position.
  const scrollDownReorder = function($activityCard) {
    let card = $activityCard.get(0);
    let nextCard = card.nextElementSibling;
    if (nextCard) {
      let description = $(nextCard).find(".activity-description");
      if (description != null) {
        tinymce.get(description.attr("id"))?.remove();
      }
      card.parentNode.insertBefore(nextCard, card);
      initTinyMce();
      updateActivityOrder();
      updateReorderButtonStates($(card));
      updateReorderButtonStates($(nextCard));
      focusReorderButton($activityCard, "down")
      announceScreenReaderChange("Activity moved down");
    }
  }

  // Function for reordering an activity card up a position.
  const scrollUpReorder = function($activityCard) {
    let card = $activityCard.get(0);
    let previousCard = card.previousElementSibling;
    if (previousCard) {
      let description = $(card).find(".activity-description");
      if (description != null) {
        tinymce.get(description.attr("id"))?.remove();
      }
      card.parentNode.insertBefore(card, previousCard);
      initTinyMce();
      updateActivityOrder();
      updateReorderButtonStates($(card));
      updateReorderButtonStates($(previousCard));
      focusReorderButton($activityCard, "up");
      announceScreenReaderChange("Activity moved up");
    }
  }

  // Add the addActivity function to the add buttons
  // Send the asset card, which should have the data attached to it
  $(".immersive-asset-card__action-button_add").on("click", function () {
    const assetCard = $(this).closest(".immersive-asset-card");
    addActivityFromAssetCard(assetCard);

    // Announce that an activity was added via screen readers
    const dataType = assetCard.data("assetType");
    const announcement = `"${dataType}" activity has been added to the assignment`;
    announceScreenReaderChange(announcement);
  });

  // Edit the text of a visually hidden element to trigger a screen reader announcement
  const announceScreenReaderChange = (announcementText) => {
    const announcement = document.querySelector(
        "#screen-reader-announcement",
    );
    // Alternate including a period to force screen readers to read identical text
    if (announcement.textContent.slice(-1) === ".") {
      announcement.textContent = announcementText;
    } else {
      announcement.textContent = announcementText + ".";
    }
  }

  ///// RIGHT SIDE /////

  const initializeAssignmentDescription = function() {
    let assignmentDescription = $("#assignment-description")
    tinymce.init({
      selector: "textarea#" + assignmentDescription.attr("id"),
      plugins: "lists",
      menubar: false,
      statusbar: false,
      browser_spellcheck: true,
      contextmenu: false,
      height: $(assignmentDescription).height(),
      toolbar: "bullist | bold italic | forecolor",
      lists_indent_on_tab: false,
      paste_as_text: true,
      content_style: tinyMceContentStyle,
      formats: {
        bold: { inline: "b" },
        italic: { inline: "i" },
      },
      extended_valid_elements: "b,i",
      invalid_elements: "em strong",
      init_instance_callback: function (editor) {
        editor.on("focus", function (e) {
          // Show the toolbar when gaining focus.
          $(e.target.iframeElement
            .closest(".tox-editor-container")
            .querySelector(".tox-editor-header")
          ).show();
          // Increase the height of the description box.
          $(e.target.iframeElement.closest(".tox-tinymce")).height(300);
        });
        editor.on("blur", function (e) {
          // Hide the toolbar when losing focus.
          updateSessionData();
          $(e.target.iframeElement
            .closest(".tox-editor-container")
            .querySelector(".tox-editor-header")
          ).hide();
          // Shrink the height of the description box back to its original.
          $(e.target.iframeElement.closest(".tox-tinymce")).height($(assignmentDescription).height());
        });
      },
      setup: function (editor) {
        setupDescriptionEditorAccessibility(editor);
        editor.on("init", function (e) {
          $(e.target.iframeElement.closest(".tox-tinymce")).addClass("builder-container__rounded-border")
          // Hide the toolbar by default.
          $(e.target.iframeElement
            .closest(".tox-editor-container")
            .querySelector(".tox-editor-header")
          ).hide();
        });
      },
    });
  }

  // Function for the drag and drop reordering of the activity list
  $(activityListIdSelector).sortable({
    tolerance: "pointer",
    opacity: 0.5,
    containment: activityListIdSelector,
    handle: ".builder-activity-card__controls-drag",
    receive: function (event, ui) {
      // Add the new activity and make sure the whole right side is droppable again
      let $assetCard = $(this).find(".immersive-asset-card");
      addActivityFromAssetCard(ui.item, $assetCard.index());
      $assetCard.remove();
      $(droppableAreaIdSelector).droppable("enable");
    },
    start: function(event, ui) {
      ui.placeholder.css({
        visibility: "visible",
        border: "2px dashed #a7a9ac"
      });
      $(this).find(".activity-description").each(function () {
        let editor = tinymce.get($(this).attr("id"));
        editor.remove();
      });
    },
    over: function(event, ui) {
      // Disable droppable for the whole area so we only drop once
      $(droppableAreaIdSelector).droppable("disable");
    },
    out: function(event, ui) {
      // Enable droppable for the whole area again
      $(droppableAreaIdSelector).droppable("enable");
      $(this).find(".activity-description").each(function () {
        initTinyMce();
        $(this.closest(".builder-activity-card__description-container").querySelector(".tox-editor-header")).hide();
      });
    },
    stop: function (event, ui) {
      $(droppableAreaIdSelector).removeClass("builder-container__right-droppable-area_active");
      $(droppableAreaIdSelector).removeClass("builder-container__right-droppable-area_ready");
      $(this).find(".activity-description").each(function () {
        initTinyMce();
        $(this.closest(".builder-activity-card__description-container").querySelector(".tox-editor-header")).hide();
      });
      updateActivityOrder();
      $(activityListIdSelector).children(".builder-activity-card").each(function (index, activity) {
        updateReorderButtonStates($(activity));
      });
    },
  });
  // Variable to make sure we only drop when we have released the mouse
  let mouseDown = false;
  $(builderContainerIdSelector).mousedown(function () { mouseDown = true; });
  $(builderContainerIdSelector).mouseup(function () { mouseDown = false; });

  // Functionality for reordering activities by drag-and-drop
  $(droppableAreaIdSelector).droppable({
    over: function (e, ui) {
      if (!ui.draggable[0].classList.contains("immersive-asset-card")) {
        return;
      }
      activityAreaDragOverHandler();
    },
    out: function (event, ui) {
      if (!ui.draggable[0].classList.contains("immersive-asset-card")) {
        return;
      }
      activityAreaDragLeaveHandler();
    },
    drop: function (event, ui) {
      // Check if we've actually released the mouse, and we're dragging an asset card
      if (!mouseDown && ui.draggable[0].classList.contains("immersive-asset-card")) {
        addActivityFromAssetCard(ui.draggable);
      }
    },
  });
  // Event handler functions for asset dragging
  const assetDragStartHandler = function (ev) {
    // Give the drop area a highlight border
    $(droppableAreaIdSelector).addClass("builder-container__right-droppable-area_active");
    // Grey out left side
    $(".builder-container__left-body").css("opacity", "0.3");
  };
  const assetDragEndHandler = function (ev) {
    // Remove highlight border
    $(droppableAreaIdSelector).removeClass("builder-container__right-droppable-area_active");
    $(droppableAreaIdSelector).removeClass("builder-container__right-droppable-area_ready");
    // Make left side look normal
    $(".builder-container__left-body").css("opacity", "1");
  };
  const activityAreaDragOverHandler = function (ev) {
    $(droppableAreaIdSelector).removeClass("builder-container__right-droppable-area_active");
    $(droppableAreaIdSelector).addClass("builder-container__right-droppable-area_ready");
  };
  const activityAreaDragLeaveHandler = function (ev) {
    $(droppableAreaIdSelector).addClass("builder-container__right-droppable-area_active");
    $(droppableAreaIdSelector).removeClass("builder-container__right-droppable-area_ready");
  };

  // Functionality for the hover states of the text areas
  document.getElementById("assignment-title").addEventListener("input", function (e) {
    this.value = this.value.replace(/\n/g, "");
  });

  // Handler for when the point value of an activity has changed.
  const onPointValueChanged = function(element) {
    // Sanitize the point value.
    if (element) {
      // If the point value is empty, set it to zero.
      if (element.value === "") {
        element.value = 0;
        // If the point value is less than the defined min, set it to the min.
      } else if (element.min !== "" && parseInt(element.value) < parseInt(element.min)) {
        element.value = parseInt(element.min);
        // If the point value is greater than the defined max, set it to the max.
      } else if (element.max !== "" && parseInt(element.value) > parseInt(element.max)) {
        element.value = parseInt(element.max);
      }
    }
    updateAssignmentPointDisplay();
  }

  const initializeFolderNamePicker = function() {
    let $folderNamePicker = $(assignmentFolderNamePickerSelector);
    let value = $folderNamePicker?.data("starting-selection");
    if (value !== undefined) {
      $folderNamePicker.val(value).trigger("change");
    }
  }

  // Initializes all activity description text areas with tinyMCE
  const initTinyMce = function() {
    tinymce.init({
      selector: ".activity-description",
      plugins: "lists",
      menubar: false,
      statusbar: false,
      browser_spellcheck: true,
      contextmenu: false,
      height: 100,
      toolbar: "bullist | bold italic | forecolor",
      lists_indent_on_tab: false,
      paste_as_text: true,
      content_style: tinyMceContentStyle,
      formats: {
        bold: { inline: "b" },
        italic: { inline: "i" },
      },
      extended_valid_elements: "b,i",
      invalid_elements: "em strong",
      init_instance_callback: function (editor) {
        editor.on("focus", function (e) {
          // Show the toolbar when gaining focus.
          $(e.target.iframeElement
            .closest(".tox-editor-container")
            .querySelector(".tox-editor-header")
          ).show();

          // Increase the height of the description box.
          $(e.target.iframeElement.closest(".tox-tinymce")).height(300);
        });
        editor.on("blur", function (e) {
          // Hide the toolbar when losing focus.
          updateSessionData();
          $(e.target.iframeElement
            .closest(".tox-editor-container")
            .querySelector(".tox-editor-header")
          ).hide();

          // Shrink the height of the description box back to its original.
          $(e.target.iframeElement.closest(".tox-tinymce")).height(100);
        });
      },
      setup: function (editor) {
        setupDescriptionEditorAccessibility(editor);
        editor.on("init", function (e) {
          // Hide the toolbar by default.
          $(e.target.iframeElement
            .closest(".tox-editor-container")
            .querySelector(".tox-editor-header")
          ).hide();

          // Show the activity card data (e.g. activity title, description, etc.)
          $(e.target.iframeElement.closest(".builder-activity-card__description-container")).show();
        });
      },
    });
  }

  // Checks if the provided URL is valid or not for an activity.
  const isValidUrl = function(url) {
    try {
      let urlObj = new URL(url);
      return urlObj.protocol === "https:";
    } catch (e) {}
    return false;
  }

  // Sets the state of the "Add Link" error based on the provided value.
  const setAddLinkErrorState = function(visible) {
    let errorContainer = $("#add-link-error-container");
    const hiddenClass = "add-link-activity__error-container_hidden";
    if (visible && errorContainer.hasClass(hiddenClass)) {
      errorContainer.removeClass(hiddenClass);
    } else if (!visible && !errorContainer.hasClass(hiddenClass)) {
      errorContainer.addClass(hiddenClass);
    }
  }

  const setAddLinkButtonState = function(enabled) {
    let $button = $(addLinkButtonIdSelector);
    const disabledClass = "add-link-activity__add-button_disabled";
    if (enabled) {
      $button.removeClass(disabledClass);
      $button.removeAttr("aria-disabled");
      $button.removeAttr("disabled");
    } else {
      if (!$button.hasClass(disabledClass)) {
        $button.addClass(disabledClass);
      }
      $button.attr("aria-disabled", true);
      $button.attr("disabled", "disabled");
    }
  }

  // Clears the Add Link input field.
  const clearLinkInputField = function() {
    setAddLinkButtonState(false);
    $(addLinkInputIdSelector).val("");
    $(addLinkButtonIdSelector).blur();
  }

  // Updates the reorder control buttons for the provided activity card.
  const updateReorderButtonStates = function($activityCard) {
    if ($activityCard) {
      let $reorderButtonUp = $activityCard.find("[data-reorder-direction='up']");
      if ($reorderButtonUp.length) {
        if ($activityCard.get(0).previousElementSibling) {
          setButtonState($reorderButtonUp, true);
        } else {
          setButtonState($reorderButtonUp, false);
        }
      }
      let $reorderButtonDown = $activityCard.find("[data-reorder-direction='down']");
      if ($reorderButtonDown.length) {
        if ($activityCard.get(0).nextElementSibling) {
          setButtonState($reorderButtonDown, true);
        } else {
          setButtonState($reorderButtonDown, false);
        }
      }
    }
  };

  // Focus the same reorder button unless the card has reached either end
  const focusReorderButton = function($activityCard, direction) {
    let $reorderButtonUp = $activityCard.find("[data-reorder-direction='up']");
    let $reorderButtonDown = $activityCard.find("[data-reorder-direction='down']");

    if (direction === "up") {
      if ($activityCard.is(":first-child")) {
        $reorderButtonDown.focus();
      }
      else {
        $reorderButtonUp.focus();
      }
    }
    else if (direction === "down") {
      if ($activityCard.is(":last-child")) {
        $reorderButtonUp.focus();
      }
      else {
        $reorderButtonDown.focus();
      }
    }
    $activityCard[0].scrollIntoView({ behavior: "smooth" })
  };

  // Function for dropping the current focus of the DOM.
  const dropCurrentFocus = function() {
    if (document.activeElement && typeof document.activeElement.blur === "function") {
      document.activeElement.blur();
    }
  }

  // Function for determining if the right side is enabled.
  const rightSideEnabled = function() {
    return $("#builder-container-right-side").prop("inert") === false;
  }

  // Function for updating the activity counter.
  const updateActivityCounter = function() {
    $("#collapsed-bar-activity-count")?.text($(activityListIdSelector)?.children().length);
  }

  // Function for performing the activity card reorder animation.
  const reorderActivityCards = function(activityList, reorderFunction) {
    let activityCards = Array.from(activityList.children);

    // Get the rects (positions) of the activity cards as they are now.
    let rectsBeforeReorder = new Map();
    activityCards.forEach(activityCard => {
      rectsBeforeReorder.set(activityCard, activityCard.getBoundingClientRect());
    });

    // Reorder the activity cards.
    reorderFunction();

    // Get the rects (positions) of the activity cards after the reorder.
    const rectsAfterReorder = new Map();
    activityCards.forEach(activityCard => {
      rectsAfterReorder.set(activityCard, activityCard.getBoundingClientRect());
    });

    // Determine the change in position of the activity cards.
    activityCards.forEach(activityCard => {
      let beforeRect = rectsBeforeReorder.get(activityCard);
      let afterRect = rectsAfterReorder.get(activityCard);

      let deltaX = beforeRect.left - afterRect.left;
      let deltaY = beforeRect.top - afterRect.top;
      activityCard.style.transition = "none";
      activityCard.style.transform = `translate(${deltaX}px, ${deltaY}px)`;
    });

    // Animate the activity cards to their new positions.
    requestAnimationFrame(() => {
      activityCards.forEach(activityCard => {
        activityCard.style.transition = "transform 250ms ease";
        activityCard.style.transform = "";
      });
    });
  }

  $(addLinkButtonIdSelector).on("click", function () {
    let addLinkInputField = $(addLinkInputIdSelector);
    let inputValue = addLinkInputField.val();
    if (inputValue != null && inputValue !== "") {
      addActivityFromLink(inputValue, true);
      clearLinkInputField();
    }
  });

  const pasteButton = document.querySelector("#paste-link-button");
  pasteButton.addEventListener("click", async () => {
    try {
      let clipboardText = await navigator.clipboard.readText();
      if (clipboardText !== "" && clipboardText !== undefined) {
        $(addLinkInputIdSelector).val(clipboardText);
        if (isValidUrl(clipboardText)) {
          // Valid URL
          setAddLinkErrorState(false);
          setAddLinkButtonState(true);
        } else {
          // Invalid URL
          setAddLinkErrorState(true);
          setAddLinkButtonState(false);
        }
      } else {
        // Empty URL
        setAddLinkErrorState(false);
        setAddLinkButtonState(false);
      }
    } catch (e) {}
    pasteButton.blur();
  });

  // Handles error handling for when the add link input field has changed values.
  $(addLinkInputIdSelector).on("change", function () {
    let inputValue = $(this).val();
    if (inputValue !== "" && inputValue !== undefined) {
      if (isValidUrl(inputValue)) {
        // Valid URL
        setAddLinkErrorState(false);
        setAddLinkButtonState(true);
      } else {
        // Invalid URL
        setAddLinkErrorState(true);
        setAddLinkButtonState(false);
      }
    } else {
      // Empty URL
      setAddLinkErrorState(false);
      setAddLinkButtonState(false);
    }
  });

  // Handles error handling for the add link input field when it loses focus.
  $(addLinkInputIdSelector).on("blur", function () {
    let inputValue = $(this).val();
    if (inputValue === "" || inputValue == null) {
      setAddLinkErrorState(false);
      setAddLinkButtonState(false);
    }
  });

  // Fires an event when the preview button is selected within the preview overlay.
  $(".immersive-asset-card__action-button_preview").on("click", function (event) {
    let assetCard = $(this).closest(".immersive-asset-card");
    if (assetCard != null) {
      let assetID = assetCard.data("asset-id");
      let className = assetCard.data("class-name");
      if (assetID != null && className != null) {
        // Sends out a request to show the preview modal.
        switch (className) {
          case "contentful_asset":
            $.ajax({
              url: "/contentful_assets/" + assetID + "/preview",
              type: "GET",
              data: { asset_type_id: assetCard.data("assetTypeId") }
            });
            break;
          case "custom_content":
            $.ajax({ url: "/custom_contents/" + assetID + "/preview", type: "GET" });
            break;
          default:
            break;
        }
      }
    }
  });

  // Listener for when the "send notification" checkbox on the publish confirmation modal changes value.
  $("#confirm-send-notification").on("change", function() {
    $("#send-notification-form-field").val($(this).prop("checked"));
  });

  // Listener for when the folder dropdown has selected a new option.
  $(assignmentFolderNamePickerSelector).on("change", function() {
    let $folderNameInput = $("#assignment-group-folder-name-input-container")
    if ($(this).val() === "-1") {
      $folderNameInput.prop("inert", false);
      $folderNameInput.css("height", $folderNameInput.prop("scrollHeight") + "px");
      $folderNameInput.attr("aria-hidden", false)
    } else {
      $folderNameInput.prop("inert", true);
      $folderNameInput.css("height", 0);
      $folderNameInput.attr("aria-hidden", true)
    }
    updateSessionData();
  });

  // Listener for when the "start from scratch" button is selected when the resume modal appears.
  $("#assignment-start-from-scratch-button").on("click", function() {
    setButtonState($(this), false);
    let form = $("#immersive_assignment_form").get(0);
    // Clears the saved builder session data and reloads the page.
    $.ajax({
      url: "/immersive_assignments/builder/clear_saved_form_data",
      type: "POST",
      success: function(response) {
        location.reload();
      }
    });
  });

  // Handles when the assignment title loses focus.
  $("#assignment-title").on("blur", function() {
    updateSessionData();
  });

  // Handles when the start date picker value changes.
  $(startDatePicker).on("change", function() {
    updateSessionData();
  });

  // Handles when the due date picker value changes.
  $(dueDatePicker).on("change", function() {
    updateSessionData();
  });

  // Handles when the folder name input loses focus.
  $(folderName).on("blur", function() {
    updateSessionData();
  });

  $("#builder-cancel-resource-changes-button").on("click", function() {
    const closeUrl = $(this).data("closeBuilderUrl");
    window.close();
    if (closeUrl) {
      window.location.assign(closeUrl);
    }
  });

  // Handler for when the builder right side collapse button is clicked.
  $("#builder-collapse-right-button").on("click", function() {
    dropCurrentFocus();
    let $rightSide = $("#builder-container-right-side");
    $rightSide.addClass("builder-container__right-collapsed");
    $rightSide.prop("inert", true);

    let $collapsedBar = $("#builder-collapsed-bar");
    $collapsedBar.addClass("builder-collapsed-bar__visible");
    $collapsedBar.one("transitionend", function(e) {
      if (e.originalEvent.propertyName === "transform") {
        $collapsedBar.prop("inert", false);
        $collapsedBar.find("#builder-expand-right-button").focus();
      }
    });
    updateActivityCounter();
  });

  // Handler for when the builder right side expand button is clicked.
  $("#builder-expand-right-button").on("click", function() {
    dropCurrentFocus();
    let $rightSide = $("#builder-container-right-side");
    $rightSide.removeClass("builder-container__right-collapsed");
    $rightSide.one("transitionend", function(e) {
      if (e.originalEvent.propertyName === "transform") {
        $rightSide.prop("inert", false);
        $rightSide.find("#builder-collapse-right-button").focus();
      }
    });

    let $collapsedBar = $("#builder-collapsed-bar");
    $collapsedBar.removeClass("builder-collapsed-bar__visible");
    $collapsedBar.prop("inert", true);
  });

  // Handler for when the builder right side collapse button is clicked.
  $("#builder-collapse-filters-button").on("click", function() {
    dropCurrentFocus();
    let $filters = $("#builder-filters");
    $filters.addClass("builder-filters__collapsed");

    let $collapsedBar = $("#builder-collapsed-filters-bar");
    $collapsedBar.addClass("builder-collapsed-filters-bar__visible");
    $collapsedBar.one("transitionend", function(e) {
      if (e.originalEvent.propertyName === "transform") {
        $collapsedBar.prop("inert", false);
        $collapsedBar.find("#builder-expand-filters-button").focus();
      }
    });
  });

  // Handler for when the builder right side expand button is clicked.
  $("#builder-expand-filters-button").on("click", function() {
    dropCurrentFocus();
    let $filters = $("#builder-filters");
    $filters.removeClass("builder-filters__collapsed");
    $filters.one("transitionend", function(e) {
      if (e.originalEvent.propertyName === "transform") {
        $filters.prop("inert", false);
        $filters.find("#builder-collapse-filters-button").focus();
      }
    });

    let $collapsedBar = $("#builder-collapsed-filters-bar");
    $collapsedBar.removeClass("builder-collapsed-filters-bar__visible");
    $collapsedBar.prop("inert", true);
  });

  $(".assignment-settings__edit-button").on("click", function() {
    $(this).attr("assignment-settings-return-button", true);
  });

  // Handles setting up the initial state of the builder page.
  let initialize = function() {
    initializeFolderNamePicker();
    initializeAssignmentDescription();
    initializeBuilderTooltips();
    initializeAssetCardTitleTooltips();
    $(activityListIdSelector).children("li").each(function (index, activity) {
      initActivityCard($(activity), false);
    });

    // Validate assignment and activity names on load (including after session restoration)
    validateAssignmentName();
    document.querySelectorAll(".activity-title").forEach(validateActivityName);

    handleActivityCountChanged();

    let activityCount = $(activityListIdSelector).children().length
    // Show unsaved changes popup if there are activities in the session data
    if (activityCount > 0) {
      $("#unsaved-changes-popup").modal("toggle");
    }
  }
  initialize();
});
